export default __webpack_public_path__ + "static/media/BH.da443144.svg";